import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Check, X } from 'lucide-react';
export const WhoIsThisFor = () => {
  const isFor = ['Personas que sufren ataques de pánico o ansiedad generalizada.', 'Cristianos que se sienten culpables por su lucha mental y emocional.', 'Jóvenes y adultos que despiertan con angustia o miedo al futuro.', 'Quienes buscan una solución práctica que combine fe y fisiología.'];
  const isNotFor = ['Quienes buscan un tratado teológico académico o histórico.', 'Personas que no están dispuestas a dedicar 5 minutos a la práctica de respiración y lectura.', 'Quienes buscan una fórmula mágica que no requiera compromiso personal.'];
  return <Section variant="navy" data-id="element-166">
      <div className="grid md:grid-cols-2 gap-8" data-id="element-167">
        <FadeIn direction="right" className="bg-navy-light p-8 rounded-2xl border-t-4 border-t-green-500/50" data-id="element-168">
          <h3 className="text-2xl font-bold mb-8 text-cream" data-id="element-169">Para ti si...</h3>
          <ul className="space-y-6" data-id="element-170">
            {isFor.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-171">
                <div className="bg-green-500/10 p-1 rounded-full mt-1" data-id="element-172">
                  <Check className="w-4 h-4 text-green-400" data-id="element-173" />
                </div>
                <span className="text-cream-muted" data-id="element-174">{item}</span>
              </li>)}
          </ul>
        </FadeIn>

        <FadeIn direction="left" delay={0.2} className="bg-navy-light p-8 rounded-2xl border-t-4 border-t-red-500/30 opacity-80" data-id="element-175">
          <h3 className="text-2xl font-bold mb-8 text-cream-muted" data-id="element-176">
            No es para ti si...
          </h3>
          <ul className="space-y-6" data-id="element-177">
            {isNotFor.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-178">
                <div className="bg-red-500/10 p-1 rounded-full mt-1" data-id="element-179">
                  <X className="w-4 h-4 text-red-400/70" data-id="element-180" />
                </div>
                <span className="text-cream-muted/80" data-id="element-181">{item}</span>
              </li>)}
          </ul>
        </FadeIn>
      </div>
    </Section>;
};